module.exports = __webpack_public_path__ + "img/M5.e73057ea.png";